// Firestore del panel "dentro" de la organización: igual que 'firebase/firestore', pero collection() y doc()
// sobre la base de datos meten la ruta en orgs/{org}/... Así cada clínica cliente solo toca lo suyo.
// Todo el panel importa de aquí en vez de 'firebase/firestore'.
import { collection as _collection, doc as _doc } from 'firebase/firestore';
import { orgActual } from './org';

export * from 'firebase/firestore';

// Colecciones comunes a toda la plataforma (fuera de las organizaciones)
const GLOBALES = new Set(['orgs', 'usuarios', 'preferencias', 'tokensPush']);

const esBase = (x) => x?.type === 'firestore';

function ruta(segs) {
  if (!segs.length) return segs;
  const primera = String(segs[0]).replace(/^\/+/, '').split('/')[0];
  if (GLOBALES.has(primera)) return segs;
  const org = orgActual();
  if (!org) throw new Error(`Sin organización: ${segs.join('/')}`);
  return ['orgs', org, ...segs];
}

export function collection(base, ...segs) {
  return esBase(base) ? _collection(base, ...ruta(segs)) : _collection(base, ...segs);
}

export function doc(base, ...segs) {
  return esBase(base) && segs.length ? _doc(base, ...ruta(segs)) : _doc(base, ...segs);
}
